/** Stretches a card's title button over the whole card so a click anywhere on it triggers the button. */
export const STRETCHED_BUTTON =
  'text-start outline-none after:absolute after:inset-0 after:z-[1] after:rounded-md focus-visible:after:outline focus-visible:after:outline-4 focus-visible:after:outline-offset-[-4px] focus-visible:after:outline-border_focus';
